import React, { useEffect, useState } from 'react'
import DashboardHeader from '../Common/DashboardHeader';
import { useDispatch, useSelector } from 'react-redux';
import CustomerInput from '../reusableComponents/CustomerInput';
import SelectStatus from '../reusableComponents/SelectStatus';
import DateTo from '../reusableComponents/DateTo';
import { setKycRequestData } from '../../services/redux/KYCRequestReducer';
import showNotification from '../../services/redux/NotifcationService';
import { downloadRequest, getKycRequestListApi, reinitiateKycRequest } from '../../services/redux/ApiActions';

const ListRequests = () => {
    const kycRequestData = useSelector((state) => state.kycRequestData.kycRequestData);
    const loginData = useSelector((state) => state.login.loginData);
    const [status, setStatus] = useState('');
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')
    const [tokenId, setTokenId] = useState('')
    const dispatch = useDispatch();
    const handleDateChange = (e) => {
        if (e.target.name === 'fromDate') {
            setFromDate(e.target.value)
        } else if (e.target.name === 'toDate') {
            setToDate(e.target.value)
        }
    };


    // Sample options, replace it with your actual data
    const statusOptions = [
        { value: '1', label: 'Pending' },
        { value: '2', label: 'Success' },
        { value: '3', label: 'Failed' },
        // Add more options as needed
    ];

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };
    function getKycTypeName(kycType) {
        switch (kycType) {
            case 1:
                return 'By Date';
            case 2:
                return 'By GSTIN';
            case 3:
                return 'By Company Name';
            case 4:
                return 'By File Upload';
            case 5:
                return 'Customer KYC';
            case 6:
                return 'Vendor KYC';
            default:
                return 'Unknown KYC Type';
        }
    }
    function getSourceType(sourceType) {
        switch (sourceType) {
            case 1:
                return 'V2P';
            case 2:
                return 'Swifti';
            default:
                return 'V2P';
        }
    }
    function getStatusType(statusType) {
        switch (statusType) {
            case 1:
                return 'Pending';
            case 2:
                return 'Success';
            case 3:
                return 'Failed';
            default:
                return 'Pending';
        }
    }
    function formatDateString(dateString) {
        const dateObject = new Date(dateString);
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return dateObject.toLocaleDateString('en-US', options);
    }
    const getKycRequestList = async (item) => {
        const V2PRMPayload = {
            "filter": `${tokenId !== '' ? `id==${tokenId.slice(-1)},` : ''}${status !== '' ? `Status==${status},` : ''}${fromDate !== '' ? `requestDateTime==${fromDate},` : ''}${toDate !== '' ? `requestDateTime==${toDate}` : ''}`.replace(/,\s*$/, ''),
            "orderBy": "",
            "pageSize": 100,
            "pageNumber": 1
        }
        try {
            const KycResponse = await dispatch(getKycRequestListApi(V2PRMPayload, loginData?.token_chr))
            if (KycResponse) {
                dispatch(setKycRequestData(KycResponse))
            } else {
                showNotification('Something Went Wrong', 'error');
            }
        } catch (error) {
            showNotification(error, 'error');
        }

    }
    const downloadFile = async (item) => {
        try {
            const downloadResponse = await dispatch(downloadRequest(loginData.token_chr, item))
            if (downloadResponse) {
                // dispatch(setKycRequestData(downloadResponse))
            } else {
                showNotification('Something Went Wrong', 'error');
            }
        } catch (error) {
            showNotification(error, 'error');
        }

    }
    const reinitiateKycRequestCall = async (item) => {
        const payload = {
            requestId: item
        }
        try {
            const downloadResponse = await dispatch(reinitiateKycRequest(payload, loginData.token_chr))
            if (downloadResponse) {
                // dispatch(setKycRequestData(downloadResponse))
            } else {
                showNotification('Something Went Wrong', 'error');
            }
        } catch (error) {
            showNotification(error, 'error');
        }

    }

    const clearFilter = async (item) => {
        const V2PRMPayload = {
            "filter": '',
            "orderBy": "",
            "pageSize": 100,
            "pageNumber": 1
        }
        try {
            const KycResponse = await dispatch(getKycRequestListApi(V2PRMPayload, loginData?.token_chr))
            if (KycResponse) {
                dispatch(setKycRequestData(KycResponse))
            } else {
                showNotification('Something Went Wrong', 'error');
            }
        } catch (error) {
            showNotification(error, 'error');
        }

    }
    // "filter": `${filterCustomerName !== '' ? `customerName@=${filterCustomerName},` : ''}${filterCustomerEmail !== '' ? `email@=${filterCustomerEmail},` : ''}${filterCustomerPhone !== '' ? `phone@=${filterCustomerPhone}` : ''}`.replace(/,\s*$/, ''),

    useEffect(() => {
        getKycRequestList()
    }, [])

    return (
        <body className='mailsentbody'>
            <div >
                <div className="rightElement">
                    <DashboardHeader />
                    <div className="grid mt-6 grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                        <div className="col-span-12 md:col-span-10 lg:col-span-10 ">
                            <div className="flex items-center justify-between mt-2 p-2">
                                <div className="col-span-6">
                                    <h1 className="text-4xl font-normal ">KYC Request List</h1>
                                </div>
                                <div className="col-span-6 text-right">
                                    <button className="px-4 py-2 border border-sky-700 text-sky-700 rounded hover:bg-sky-700 hover:text-white" data-toggle="modal"

                                    >
                                        Create New KYC Request
                                    </button>
                                </div>

                            </div>
                            <div className='bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg'>
                                <div className="grid mt-5 grid-cols-12 gap-4 mb-5">
                                    <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                                        <label for="token" className="block text-md font-medium leading-6 text-gray-900">Token No.</label>
                                        <CustomerInput
                                            value={tokenId}
                                            onChange={(e) => setTokenId(e.target.value)}
                                            inputStyles={{ padding: '12px' }} />
                                    </div>
                                    <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                                        <label for="status" className="block text-md font-medium leading-6 text-gray-900">Status</label>
                                        <SelectStatus
                                            inputStyles={{ padding: '12px' }}
                                            value={status}
                                            onChange={handleStatusChange}
                                            options={statusOptions}
                                        />
                                    </div>
                                    <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                                        <label for="dateFrom" className="block text-md font-medium leading-6 text-gray-900">Request Date From</label>
                                        <DateTo
                                            name='fromDate'
                                            inputStyles={{ padding: '12px' }}
                                            selectedDate={fromDate}
                                            onDateChange={handleDateChange}
                                        />
                                    </div>
                                    <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                                        <label for="dateTo" className="block text-md font-medium leading-6 text-gray-900">Request Date To</label>
                                        <DateTo
                                            name='toDate'
                                            inputStyles={{ padding: '12px' }}
                                            selectedDate={toDate}
                                            onDateChange={handleDateChange}
                                        />
                                    </div>
                                    <div className="col-span-12 md:col-span-6 lg:col-span-6 ">
                                        <div className="flex mt-1">
                                            <div onClick={getKycRequestList} className="vtpRm-action-button">Filter list</div>
                                            <div onClick={clearFilter} className="vtpRm-back-button">Clear Filter</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="overflow-x-auto mt-2 border rounded-md shadow-sm shadow-sm">
                                    <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                                        <thead className="bg-white-400">
                                            <tr>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    Sr. No.
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    Token No.
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    KYC Type
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    Source
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    Request Date/Time
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    Status
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider border-r-2 border-black-300">
                                                    Generated Date/Time
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-bold text-black uppercase tracking-wider">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {kycRequestData?.value.map((item, index) => (
                                                <tr key={index} className="border-t">
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{index + 1}</td>
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{`KYC${String(item.tokenNo).padStart(10, '0')}`}</td>
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{getKycTypeName(item.kycType)}</td>
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{getSourceType(item.phone)}</td>
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{formatDateString(item.requestDateTime)}</td>
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{getStatusType(item.status)}</td>
                                                    <td className="px-6 py-1 whitespace-nowrap border-r-2 border-black-300">{item.reportGenerateTime ? formatDateString(item.reportGenerateTime) : ''}</td>

                                                    <td className="px-6 py-1 whitespace-nowrap ">
                                                        {item.status === 3 ? <>
                                                            <button
                                                                onClick={() => reinitiateKycRequestCall(item.tokenNo)}
                                                                className="px-2 py-1 border border-none text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                                                            >
                                                                Re-initiate
                                                            </button>
                                                        </> :
                                                            item.status === 2 ? <>
                                                                <button
                                                                    onClick={() => downloadFile(item.fileId)}
                                                                    className="px-2 py-1 border border-none text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2"
                                                                >
                                                                    Download
                                                                </button>
                                                            </> : null
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                    </div>
                </div>
            </div >
        </body >
    )
}

export default ListRequests
